import { Logger } from "neo-common";
import { Configuration } from "../Configuration";

/**
 * The ConfigurationManager class is used for parsing elements which are type of Configuration and store them for next usage.
 * @class ConfigurationManager
 */
export class ConfigurationManager {
    /**
     * Trace to browser console.
     * @method log
     * @param data any
     * @return void
     */
    private static log(data: any): void {
        if (DEBUG) {
            Logger.debugGroup("ConfigurationManager", data);
        }
    }

    /**
     * Parse configuration from xml and store them for next usage.
     * @method parseElements
     * @param startNode Element
     * @return void
     */
    static parseElements(startNode: Element): void {
        if (!startNode) {
            return;
        }

        ConfigurationManager.getNodesList(startNode.firstElementChild)
            .reverse()
            .filter((node: Element) => node.hasAttribute("Class") && node.getAttribute("Class") === "Configuration")
            .forEach((node: Element) => (Configuration.Configurations[node.nodeName] = node));
    }

    /**
     * Recursively extracts sibling nodes.
     * @method getNodesList
     * @param node Element
     * @param nodeList Array<Element>
     * @return Array<Element>
     */
    private static getNodesList(node: Element, nodeList: Array<Element> = []): Array<Element> {
        if (!node) {
            return nodeList;
        }

        if (node.nextElementSibling) {
            nodeList = ConfigurationManager.getNodesList(node.nextElementSibling, nodeList);
        }

        return nodeList.concat(node);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Managers/ConfigurationManager.ts
 **/